// used to filter data by multiple values (key and value are arrays)
export function filtration(data, keys, values) {
	return data.filter(item => {
		return keys.every((key, i) => {
			return String(values[i]).includes(String(item[key] || null))
		})
	})
}
// use to get a unique array from an array of objects by key. Returns null if it finds a false value
export function gettingArrUniqueValues(data, key) {
	return [...new Set(data.map(item => item[key] || 'null'))]
}
